import { render, staticRenderFns } from "./LeadsListing.vue?vue&type=template&id=2cc205c3"
import script from "./LeadsListing.vue?vue&type=script&lang=js"
export * from "./LeadsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports